var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{class:_vm.classNames,attrs:{"id":_vm.id,"options":_vm.options,"disabled":_vm.disabled},on:{"change":_vm.onFieldTypeChange},model:{value:(_vm.dataTypeName),callback:function ($$v) {_vm.dataTypeName=$$v},expression:"dataTypeName"}})
}
var staticRenderFns = []

export { render, staticRenderFns }